import { TransactionMethod } from "@/interfaces/transaction-methos.enum";

export const TRANSACTION_METHODS = {
	[TransactionMethod.CASH]: "Efectivo",
	[TransactionMethod.CARD]: "Tarjeta",
	[TransactionMethod.TRANSFER]: "Transferencia",
	[TransactionMethod.YAPE]: "Yape",
	[TransactionMethod.PLIN]: "Plin",
};
